const INDIA_TIME_ZONE = "Asia/Kolkata";

export const toIndiaDateTimeInputValue = (date) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: INDIA_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date).reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export const formatIndiaDateTime = (value) => new Date(value).toLocaleString("en-IN", {
  timeZone: INDIA_TIME_ZONE,
});
